const sellingPlansActionType = {
  FETCH_SELLING_PLANS: "FETCH_SELLING_PLANS",
  FETCH_SELLING_PLANS_SUCCESS: "FETCH_SELLING_PLANS_SUCCESS",
  FETCH_SELLING_PLANS_FAILURE: "FETCH_SELLING_PLANS_FAILURE",

  // create
  CREATE_PLAN: "CREATE_PLAN",
  CREATE_PLAN_SUCCESS: "CREATE_PLAN_SUCCESS",
  CREATE_PLAN_FAILURE: "CREATE_PLAN_FAILURE",
};

export default sellingPlansActionType;
